import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import SkeletonPlaceholder from 'react-native-skeleton-placeholder';
import { useTheme } from '../../theme';
import { s, v } from '../../utils/libs';

type ReceiptItemsSkeletonProps = {
  count?: number;
};

const ReceiptItemsSkeleton: React.FC<ReceiptItemsSkeletonProps> = ({
  count = 3,
}) => {
  const { theme } = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);

  const rows = Array.from({ length: Math.max(1, count) });

  return (
    <SkeletonPlaceholder
      backgroundColor={theme.colors.border}
      highlightColor={theme.colors.surfaceSecondary}>
      <View style={styles.container}>
        {rows.map((_, idx) => (
          <View key={String(idx)} style={styles.card}>
            <View style={styles.title} />
            <View style={styles.meta} />
            <View style={styles.meta} />
            <View style={styles.metaShort} />
            <View style={styles.input} />
          </View>
        ))}
      </View>
    </SkeletonPlaceholder>
  );
};

const createStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      gap: v(10),
    },
    card: {
      borderWidth: 1,
      borderColor: theme.colors.border,
      borderRadius: theme.borderRadius.md,
      padding: s(10),
      gap: v(8),
      backgroundColor: theme.colors.surface,
    },
    title: {
      width: '70%',
      height: v(18),
      borderRadius: s(6),
    },
    meta: {
      width: '52%',
      height: v(12),
      borderRadius: s(6),
    },
    metaShort: {
      width: '42%',
      height: v(12),
      borderRadius: s(6),
    },
    input: {
      width: '100%',
      height: v(50),
      borderRadius: theme.borderRadius.md,
    },
  });

export default ReceiptItemsSkeleton;
